import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Table,
  TableCell,
  TableBody,
  TableHead,
  TableContainer,
  TableRow,
  Typography,
  Button
} from '@material-ui/core'
import moment from 'moment'
import { makeStyles } from '@material-ui/core/styles'
import { Close } from '@material-ui/icons'

import classes from './CreationValidator.module.scss'

const useStyles = makeStyles({
  root: {
    width: '100%',
    overflow: 'hidden'
  },
  container: {
    maxHeight: 340,
  },
})

export default function CreationValidator(props) {
  const classes2 = useStyles()
  const { openDialog, title, close, rawData = [], handeSave, header } = props
  return (
    <Dialog
      fullWidth
      maxWidth='lg'
      onClose={close}
      aria-labelledby='customized-dialog-title'
      open={openDialog}
      className={classes.successroot}
      PaperProps={{ style: { display: 'flex' } }}
    >
      <div className={classes.beam}>
        <Typography className={classes['title-header']}>
          {title}
        </Typography>
        <IconButton
          aria-label='close'
          id='success-close-button'
          className={classes['close-button']}
          onClick={close}
        >
          <Close />
        </IconButton>
      </div>
      <DialogContent className={classes2.root}>
        <TableContainer className={classes2.container}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {header.map((item, index) => (
                  <TableCell style={{ fontWeight: 'bold' }}>{item}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rawData.map((item, index) => (
                <TableRow>
                  <TableCell>{item.crfNo}</TableCell>
                  <TableCell>{`${item.user.firstName} ${item.user.lastName}`}</TableCell>
                  <TableCell>{item.role}</TableCell>
                  <TableCell>{item.action}</TableCell>
                  <TableCell>{item.status}</TableCell>
                  <TableCell>{moment(item.date).format('MM/DD/YYYY')}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <div className={classes.button}>
        <Button
          variant='contained'
          className={classes['button-positive']}
          onClick={() => {
            // setLoading(false)
            close(false)
          }}
        >
          OK
        </Button>
      </div>
    </Dialog>
  )
}
